import { useContext } from "react";
import CheckUpContext from "../../context/check-up";
import CheckUpRequests from "./check-up-requests";
import CheckUpPickUpPointResume from "./check-up-pick-up-point-resume";

const CheckUpContent = () => {
  const { currentRequest } = useContext(CheckUpContext);
  return (
    <div className="wrapper wrapper--app">
      {["DRAFT", "SENT", "IN_PROGRESS"].includes(currentRequest?.status) && (
        <div className="app-content__section">
          <CheckUpPickUpPointResume />
        </div>
      )}
      <CheckUpRequests />
    </div>
  );
};

export default CheckUpContent;
